function setBodyOverflow($, sidebarIsOpen = false) {
    if (sidebarIsOpen) {
        $('body').css('overflow', 'hidden');
    } else {
        $('body').css('overflow', '');
    }
}

function initSidebar($, $sidebar) {
    const $closeButton = $sidebar.find('.js-sidebar-close');
    const $sidebarOverlay = $sidebar.find('.js-sidebar-overlay');

    $('.js-sidebar-trigger').on('click', () => {
        $sidebar.addClass('sidebar--open');
        setBodyOverflow($, true);
    });

    $closeButton.on('click', () => {
        $sidebar.removeClass('sidebar--open');
        setBodyOverflow($);
    });

    $sidebarOverlay.on('click', () => {
        $sidebar.removeClass('sidebar--open');
        setBodyOverflow($);
    });

    $(document).on('keydown', (e) => {
        if (e.key === 'Escape') {
            $sidebar.removeClass('sidebar--open');
            setBodyOverflow($);
        }
    });
}

export function sidebarLoader($) {
    $('.js-sidebar').each((index, sidebar) => {
        initSidebar($, $(sidebar));
    });
}
